import _findIndex from 'lodash/findIndex';

import initialState from './initialState';
import actionTypes from './actionTypes';

const infiniteTablePropertiesReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_TABLE_META_PROPERTIES_SUCCESS: {
            const { columns, records, contextMenuItems, explorerViews, totalRowCount, tableName } = action.payload;
            return {
                ...state,
                agGridDefaultColDef: columns,
                agGridRowData: [],
                agGridContextMenuItems: contextMenuItems,
                totalRowCount: totalRowCount,
                explorerViews: explorerViews,
                tableName: tableName,
            };
        }
        case actionTypes.GET_SOURCE_EXPLORER_VIEWS_SUCCESS:
            return {
                ...state,
                explorerViews: action.payload,
            };
        case actionTypes.GET_RECON_EXPLORER_VIEWS_SUCCESS:
            return {
                ...state,
                explorerViews: action.payload,
            };
        case actionTypes.CLEAN_EXPLORER_VIEWS:
            return {
                ...state,
                explorerViews: action.payload,
            };
        case actionTypes.GET_VIEW_RECORDS_SUCCESS: {
            return {
                ...state,
                virtualColumns: action.payload,
            };
        }
        case actionTypes.GET_VIEW_SUCCESS: {
            return {
                ...state,
                virtualRecords: action.payload,
            };
        }
        case actionTypes.GET_FILES_FROM_SERVER: {
            return {
                ...state,
                filesFromServer: action.payload,
            };
        }
        case actionTypes.GET_FILES_FROM_CONTAINER: {
            return {
                ...state,
                filesFromContainer: action.payload
            }
        }
        case actionTypes.SET_LINKED_DATA: {
            return {
                ...state,
                linkedGcDataArray: action.payload
            }
        }
        default:
            return state;
    }
};

export default infiniteTablePropertiesReducer;
